// extracted by mini-css-extract-plugin
export default {"imgdiv":"ef187f2272 b1efaf35bd","img":"_24a88c8cda _698b8b8f33"};